var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 67.5,
    fill: "#DBDBDB",
    stroke: "url(#paint0_linear_313_8022)",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.892 54.5253C67.892 53.5391 68.6914 52.7396 69.6777 52.7396C70.6639 52.7396 71.4634 53.5391 71.4634 54.5253L71.4634 67.8919L84.83 67.8919C85.8162 67.8919 86.6157 68.6914 86.6157 69.6776C86.6157 70.6638 85.8162 71.4633 84.83 71.4633H71.4634L71.4634 84.8299C71.4634 85.8161 70.6639 86.6156 69.6777 86.6156C68.6914 86.6156 67.892 85.8161 67.892 84.8299L67.892 71.4633L54.5254 71.4633C53.5392 71.4633 52.7397 70.6638 52.7397 69.6776C52.7397 68.6914 53.5392 67.8919 54.5254 67.8919L67.892 67.8919L67.892 54.5253Z",
    fill: "url(#paint1_linear_313_8022)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_313_8022",
    x1: -0.00000244095,
    y1: 63.3333,
    x2: 140,
    y2: 63.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_313_8022",
    x1: 59.997,
    y1: 77.6747,
    x2: 77.6747,
    y2: 59.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileInput);
export default __webpack_public_path__ + "static/media/profileInput.ab4ba877f59c4f6e0a7ca141469ff99c.svg";
export { ForwardRef as ReactComponent };